export const getResource = () => {
    return {
        seedFarmCode: '',
        mainCategorySource: [],
        rawSubCategorySource: [],
        brandSource: [],
        serialSource: [],
        unitSource: [],
        packageSource: [],
        masterSource: [],
        allRegionInfo: [],
        provinceOptions: [],
        cityOptions: [],
        distOptions: [],
        approvalSource: []
    };
};

export const setResource = (resource, apiResponse) => {
    resource.seedFarmCode = apiResponse.data.seedFarmCode;

    resource.mainCategorySource = apiResponse.data.mainCategories.records;
    resource.rawSubCategorySource = apiResponse.data.subCategories.records;
    resource.brandSource = apiResponse.data.brands.records;
    resource.serialSource = apiResponse.data.serials.records;
    resource.unitSource = apiResponse.data.units.records;
    resource.packageSource = apiResponse.data.packages.records;
    resource.masterSource = apiResponse.data.masters.records;

    resource.allRegionInfo = apiResponse.data.allRegions;
    resource.provinceOptions = apiResponse.data.allRegions.filter(r => r.regionType === 1);
    resource.cityOptions = [];
    resource.distOptions = [];
};
